// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"_4-z"};